import * as React from "react";
var UserContext = /*#__PURE__*/ React.createContext({
    status: {
        loading: true,
        error: undefined
    },
    company: {
        id: "",
        name: ""
    },
    sub: "",
    email_verified: "",
    given_name: "",
    family_name: "",
    email: "",
    username: "",
    companyName: "",
    userpoolID: "",
    role: ""
});
export { UserContext };
